export default __webpack_public_path__ + "static/small-image-sportplus-2-7a9777ae7d34b26f353975cc7fc4c644.png";